import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { IdentityDocumentDetail } from "@/features/individuals/components/identity-document-detail"
import { individualQueries } from "@/queries/individuals"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/identity/$documentId/"
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      individualQueries.identityDocuments(params.individualId)
    ),
  component: IdentityDocumentPage,
})

function IdentityDocumentPage() {
  const { individualId, documentId } = Route.useParams()
  const navigate = useNavigate()

  return (
    <IdentityDocumentDetail
      individualId={individualId}
      documentId={documentId}
      onRemoved={() =>
        navigate({
          from: "/$organisation",
          to: "/$organisation/individuals/$individualId/identity",
          params: { individualId },
        })
      }
    />
  )
}
